<div *ngIf="member" class="user-detail p-4">
  <h2>회원정보 상세보기</h2>

  <div class="user-detail-content">
    <div class="pb-4 mb-4">
      <h4 class="mb-3">회원정보</h4>
      <table class="table table-centered table-nowrap mb-4">
        <tr>
          <th class="col-3">이름</th>
          <td>{{ member.name ? member.name : '-' }}</td>
        </tr>
        <tr>
          <th class="col-3">이메일주소</th>
          <td>{{ member.email }}</td>
        </tr>
        <tr>
          <th class="col-3">가입 유형</th>
          <td>{{ displayName(member.loginType) }}</td>
        </tr>
        <tr>
          <th class="col-3">휴대폰번호</th>
          <td>{{ member.phone ? member.phone : '-' }}</td>
        </tr>
        <tr>
          <th class="col-3">성별</th>
          <td>{{ member.gender ? (member.gender === 'male' ? '남성' : '여성') : '-' }}</td>
        </tr>
        <tr>
          <th class="col-3">생년월일</th>
          <td *ngIf="member.birthDate">{{ member.birthDate | date : 'yyyy.MM.dd' }}</td>
          <td *ngIf="!member.birthDate">-</td>
        </tr>
        <tr>
          <th class="col-3">가입일</th>
          <td>{{ member.dateCreated | date : 'yyyy.MM.dd' }}</td>
        </tr>
        <tr>
          <th class="col-3">본인인증</th>
          <td>{{ member.phone ? '인증' : '미인증' }}</td>
        </tr>
      </table>
    </div>
    <div>
      <h4 class="mb-3">앱정보</h4>
      <table class="table table-centered table-nowrap mb-4">
        <tr>
          <th class="col-3">회원상태</th>
          <td>{{ checkActive(member) }}</td>
        </tr>
        <tr>
          <th class="col-3">마케팅동의</th>
          <td>{{ member.marketingSwitch ? '동의' : '비동의' }}</td>
        </tr>
        <tr>
          <th class="col-3">알림동의</th>
          <td>{{ member.pushSwitch ? '동의' : '비동의' }}</td>
        </tr>
        <tr>
          <th class="col-3">설치버전</th>
          <td>{{ member.appVersion ? member.appVersion : '0.0.1' }}</td>
        </tr>
        <tr>
          <th class="col-3">탈퇴사유</th>
          <td *ngIf="member.exitReason.category">
            {{ member.exitReason.category }}{{ member.exitReason.detail ? '(' + member.exitReason.detail + ')' : '' }}
          </td>
          <td *ngIf="!member.exitReason.category">-</td>
        </tr>
        <tr>
          <th class="col-3">기타 메모</th>
          <td>
            <textarea [(ngModel)]="memo" name="" id="" cols="30" rows="10"></textarea>
          </td>
        </tr>
      </table>
    </div>
  </div>
  <div class="d-flex align-items-center justify-content-center" style="gap: 1rem">
    <button (click)="close()" class="btn btn-light" type="button">닫기</button>
    <button (click)="save()" [disabled]="!memo.trim()" class="btn btn-primary" type="button">저장</button>
  </div>
</div>
